import React from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";

const NotFoundContainer = styled.article`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #267dff, #48c6ef);
`;
const NotFoundContents = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h1 {
    padding-bottom: 24px;
    color: white;
    font-size: 128px;
    font-weight: bold;
    text-align: center;
    text-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
  }
  p {
    padding-bottom: 48px;
    color: #12005e;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
  }
  button {
    color: white;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    background-color: #bf5f82;
    border: 1px solid grey;
    border-radius: 30px;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.5);

    a {
      display: block;
      width: 100%;
      height: 100%;
      padding: 16px 20px;
    }
  }
`;

const NotFound = () => {
  return (
    <div>
      <NotFoundContainer>
        <NotFoundContents>
          <h1>404</h1>
          <p>PAGE NOT FOUND</p>
          <button>
            <Link to="">Back to Home</Link>
          </button>
        </NotFoundContents>
      </NotFoundContainer>
    </div>
  );
};

export default NotFound;
